import React, {forwardRef} from 'react';
import MapContainer, {MapContainerProps} from 'components/common/MapContainer';
import {Map} from 'leaflet';
import ImageOverlayRotated from 'components/MyEvents/Track/ImageOverlayRotated';
import {EventType, MapType} from 'types/App';

const EventMapContainer = forwardRef((props: EventMapContainerProps, ref: React.ForwardedRef<Map>) => {
  const {children, hideMaps = false, event, ...rest} = props;
  return (
    <MapContainer center={event.location} zoom={event.zoom} {...rest} ref={ref}>
      {/* {subEvent.routes &&
        !hideRoutes &&
        subEvent.routes.map((route: RouteType) => <Polyline key={route.id} pathOptions={{color: route.color}} positions={route.track} />)} */}
      {event.maps &&
        !hideMaps &&
        event.maps.map((m: MapType) => (
          <ImageOverlayRotated
            key={`map-${m.url || m.id}`}
            topLeft={m.topLeft}
            topRight={m.topRight}
            bottomLeft={m.bottomLeft}
            opacity={1}
            image={`${import.meta.env.VITE_UPLOADS}/${m.url}`}
          />
        ))}
      {children}
    </MapContainer>
  );
});

EventMapContainer.displayName = 'EventMapContainer';

export default EventMapContainer;

type EventMapContainerProps = MapContainerProps & {
  hideMaps?: boolean;
  event: EventType;
};
